// extracted by mini-css-extract-plugin
module.exports = {"lottie":"styles_lottie__ZZB5X","skeleton-animation":"styles_skeleton-animation__5B_4O"};